/*
 * DeskNeko chair-cover F guard.
 * Reversible storefront-only protection for the unpublished working theme.
 * Product and variant data remain unchanged.
 */
(function () {
  'use strict'

  const pairDisplayLabel = 'Pair (2 armrest covers)'
  const pageVariantId = new URL(window.location.href).searchParams.get('variant')
  const initialForm = document.querySelector('#product-template form[action*="/cart/add"]')
  const initialVariantId = initialForm?.querySelector('[name="id"]')?.value || null
  let startupHandled = false
  let normalizing = false
  let observer = null
  let syncTimer = null

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim()
  const normalize = (value) => clean(value).toLowerCase()
  const isFValue = (value) => {
    const normalized = normalize(value)
    return /^f\s*:/.test(normalized) && normalized.includes('armrest cover')
  }
  const isPairValue = (value) => normalize(value) === 'pair'

  const parseVariants = (form) => {
    try {
      return JSON.parse(form?.dataset?.variants || '[]')
    } catch (error) {
      return []
    }
  }

  const getContext = () => {
    const form = document.querySelector('#product-template form[action*="/cart/add"]')
    const variants = parseVariants(form)
    const pairVariant = variants.find((variant) => {
      const options = variant.options || []
      return options.some(isFValue) && options.some(isPairValue)
    })

    if (!form || !pairVariant) return null

    const fIndex = pairVariant.options.findIndex(isFValue)
    const pairIndex = pairVariant.options.findIndex(isPairValue)

    if (fIndex < 0 || pairIndex < 0) return null

    return { form, variants, pairVariant, fIndex, pairIndex }
  }

  const findVariantById = (variants, id) => {
    if (!id) return null
    return variants.find((variant) => String(variant.id) === String(id)) || null
  }

  const isInvalidFVariant = (variant) => {
    if (!variant) return false
    const options = variant.options || []
    return options.some(isFValue) && !options.some(isPairValue)
  }

  const getSelectedControlValue = (wrapper) => {
    const select = wrapper?.querySelector('select.product-option')
    if (select) return select.value
    return wrapper?.querySelector('input.product-option:checked')?.value || ''
  }

  const setControlValue = (wrapper, value) => {
    if (!wrapper) return null

    const select = wrapper.querySelector('select.product-option')
    if (select) {
      const option = Array.from(select.options).find((item) => normalize(item.value) === normalize(value))
      if (!option) return null
      option.disabled = false
      option.hidden = false
      select.value = option.value
      return select
    }

    const radio = Array.from(wrapper.querySelectorAll('input.product-option')).find(
      (input) => normalize(input.value) === normalize(value)
    )
    if (!radio) return null
    radio.disabled = false
    radio.checked = true
    return radio
  }

  const restoreBoolean = (element, name, fallback) => {
    const value = element.dataset[name]
    return value === undefined ? fallback : value === 'true'
  }

  const styleArmChoices = (context, fSelected) => {
    const wrapper = context.form.querySelectorAll('.product-option-wrapper')[context.pairIndex]
    if (!wrapper) return

    const select = wrapper.querySelector('select.product-option')
    if (select) {
      Array.from(select.options).forEach((option) => {
        if (option.dataset.dnChairFOriginalDisabled === undefined) {
          option.dataset.dnChairFOriginalDisabled = String(option.disabled)
          option.dataset.dnChairFOriginalHidden = String(option.hidden)
          option.dataset.dnChairFOriginalLabel = option.textContent
        }

        if (isPairValue(option.value)) {
          option.disabled = false
          option.hidden = false
          option.textContent = fSelected ? pairDisplayLabel : option.dataset.dnChairFOriginalLabel
        } else if (fSelected) {
          option.disabled = true
          option.hidden = true
        } else {
          option.disabled = restoreBoolean(option, 'dnChairFOriginalDisabled', false)
          option.hidden = restoreBoolean(option, 'dnChairFOriginalHidden', false)
        }
      })
    }

    wrapper.querySelectorAll('input.product-option').forEach((input) => {
      const label = input.id ? wrapper.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null
      if (input.dataset.dnChairFOriginalDisabled === undefined) {
        input.dataset.dnChairFOriginalDisabled = String(input.disabled)
        input.dataset.dnChairFOriginalHidden = String(input.hidden)
        if (label) label.dataset.dnChairFOriginalLabel = label.textContent
      }

      if (isPairValue(input.value)) {
        input.disabled = false
        input.hidden = false
        if (label) {
          label.hidden = false
          label.textContent = fSelected ? pairDisplayLabel : label.dataset.dnChairFOriginalLabel
        }
      } else if (fSelected) {
        input.disabled = true
        input.hidden = true
        if (label) label.hidden = true
      } else {
        input.disabled = restoreBoolean(input, 'dnChairFOriginalDisabled', false)
        input.hidden = restoreBoolean(input, 'dnChairFOriginalHidden', false)
        if (label) label.hidden = input.hidden
      }
    })
  }

  const updateVisiblePairNote = (fSelected) => {
    const panel = document.querySelector('[data-dn-chair-panel]')
    if (!panel) return

    let note = panel.querySelector('[data-dn-chair-f-pair-note]')
    if (!note) {
      note = document.createElement('div')
      note.dataset.dnChairFPairNote = ''
      note.className = 'dn-chair-f-pair-note'
      note.setAttribute('role', 'status')
      note.setAttribute('aria-live', 'polite')
      note.textContent = pairDisplayLabel
      note.style.marginTop = '.55rem'
      note.style.padding = '.58rem .72rem'
      note.style.border = '1px solid rgba(113, 132, 98, .42)'
      note.style.borderRadius = '.65rem'
      note.style.background = '#eef4ea'
      note.style.color = '#263226'
      note.style.fontWeight = '750'
      panel.querySelector('[data-dn-armrest-addon]')?.insertAdjacentElement('afterend', note)
    }

    note.hidden = !fSelected
  }

  const syncMirroredVariantIds = (context) => {
    const sourceVariantIds = new Set(context.variants.map((variant) => String(variant.id)))
    document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach((input) => {
      if (input.closest('#product-template') || sourceVariantIds.has(String(input.value))) {
        input.value = context.pairVariant.id
      }
    })
  }

  const applyPairVariant = (context) => {
    if (!context || normalizing) return false
    normalizing = true

    const wrappers = context.form.querySelectorAll('.product-option-wrapper')
    let changedControl = null
    context.pairVariant.options.forEach((value, index) => {
      changedControl = setControlValue(wrappers[index], value) || changedControl
    })

    syncMirroredVariantIds(context)
    styleArmChoices(context, true)
    updateVisiblePairNote(true)

    if (changedControl && typeof window.onChangeProductOption === 'function') {
      try {
        Promise.resolve(window.onChangeProductOption(changedControl)).finally(() => {
          normalizing = false
          window.setTimeout(syncGuard, 0)
        })
      } catch (error) {
        normalizing = false
        window.setTimeout(syncGuard, 0)
      }
    } else {
      const url = new URL(window.location.href)
      url.searchParams.set('variant', context.pairVariant.id)
      window.history.replaceState({}, '', url)
      normalizing = false
    }

    return true
  }

  const syncGuard = () => {
    const context = getContext()
    if (!context) return false

    if (!startupHandled) {
      const requestedVariant = findVariantById(context.variants, pageVariantId)
      const initialVariant = findVariantById(context.variants, initialVariantId)
      const startupVariant = isInvalidFVariant(requestedVariant) ? requestedVariant : initialVariant

      if (isInvalidFVariant(startupVariant)) {
        startupHandled = true
        return applyPairVariant(context)
      }
      startupHandled = true
    }

    const wrappers = context.form.querySelectorAll('.product-option-wrapper')
    const fSelected = isFValue(getSelectedControlValue(wrappers[context.fIndex]))
    const armValue = getSelectedControlValue(wrappers[context.pairIndex])
    const currentId = context.form.querySelector('[name="id"]')?.value
    const currentVariant = findVariantById(context.variants, currentId)

    if ((fSelected && !isPairValue(armValue)) || isInvalidFVariant(currentVariant)) {
      return applyPairVariant(context)
    }

    if (fSelected) syncMirroredVariantIds(context)
    styleArmChoices(context, fSelected)
    updateVisiblePairNote(fSelected)
    return true
  }

  const scheduleSync = (delay) => {
    window.clearTimeout(syncTimer)
    syncTimer = window.setTimeout(syncGuard, delay || 0)
  }

  const bindFormGuard = () => {
    const context = getContext()
    if (!context || context.form.dataset.dnChairFGuardBound === 'true') return
    context.form.dataset.dnChairFGuardBound = 'true'

    context.form.addEventListener('change', () => scheduleSync(0), true)
    context.form.addEventListener('submit', (event) => {
      const freshContext = getContext()
      const currentId = freshContext?.form.querySelector('[name="id"]')?.value
      const currentVariant = findVariantById(freshContext?.variants || [], currentId)
      if (freshContext && isInvalidFVariant(currentVariant)) {
        event.preventDefault()
        event.stopImmediatePropagation()
        applyPairVariant(freshContext)
      }
    }, true)
  }

  const init = () => {
    bindFormGuard()
    syncGuard()

    if (!observer) {
      observer = new MutationObserver(() => scheduleSync(20))
      const root = document.querySelector('#product-template')
      if (root) observer.observe(root, { childList: true, subtree: true })
    }

    window.setTimeout(syncGuard, 100)
    window.setTimeout(syncGuard, 300)
    window.setTimeout(syncGuard, 800)
  }

  window.addEventListener('variantChange.ecomify.product', (event) => {
    const context = getContext()
    if (context && isInvalidFVariant(event.detail)) applyPairVariant(context)
    else scheduleSync(0)
  })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }

  document.addEventListener('shopify:section:load', init)
})()
